import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';

const propTypes = {
  email: PropTypes.string.isRequired,
  ico: PropTypes.string.isRequired,
  jednotka: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  tel: PropTypes.string.isRequired,
};

export default function BasicFormData(props) {
  const {
    onChange,
    name,
    ico,
    jednotka,
    tel,
    email,
  } = props;

  return (
    <React.Fragment>
      <h4>Povinná pole:</h4>
      <TextField
        id='ico'
        label='IČ'
        value={ico}
        onChange={onChange('ico')}
        variant='outlined'
        fullWidth
        margin='dense'
        required
      />
      <TextField
        id='jednotka'
        // type='number'
        label='Počet jednotek'
        value={jednotka}
        onChange={onChange('jednotka')}
        variant='outlined'
        fullWidth
        margin='dense'
        required
      />
      <TextField
        id='name'
        label='Kontaktní osoba'
        value={name}
        onChange={onChange('name')}
        variant='outlined'
        fullWidth
        margin='dense'
        required
      />
      <TextField
        id='tel'
        label='Telefon'
        value={tel}
        onChange={onChange('tel')}
        variant='outlined'
        fullWidth
        margin='dense'
        required
      />
      <TextField
        id='email'
        label='E-mail'
        value={email}
        onChange={onChange('email')}
        variant='outlined'
        fullWidth
        margin='dense'
        required
      />
    </React.Fragment>
  );
}

BasicFormData.propTypes = propTypes;
